module.exports = __webpack_public_path__ + "img/orange-house.c9802fc5.svg";